/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/styles";
import { FormControlLabel, Checkbox, Snackbar, Divider } from "@material-ui/core";
import { ReflexContainer, ReflexSplitter, ReflexElement } from "react-reflex";
import { Alert } from "@material-ui/lab";
import uiConf from "../../config/uiConf";

import apiClient from "../../lib/common/apiClient";
import checkValidation from "../../lib/utils/checkValidation";
import checkConditionWithMsg from "../../lib/utils/checkConditionWithMsg";

import Dialog from "../dialog/functional/Dialog";
import DialogContent from "../dialog/functional/DialogContent";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import MomSysSelectStadnardShipDetail from "../screens/MomSysSelectStandardShipDetail";
import AutoForm from "../form/functional/AutoForm";
import "../grid/layout/DataGridMomSysOrderPurchase.css"
import layoutConf from "../../config/layoutConf";
import DialogHeaderWithClose from "../dialog/functional/DialogHeaderWithClose";
import getSpecific from "../../lib/api/getSpecific";
import {debounce} from "lodash";

const useStyles = makeStyles((theme) => ({

    keepOpenSwitch: {
        marginLeft: "8px"
    },

    label: {
        fontSize: "smaller",
        color: theme.palette.primary.text
    },

}));

function MomSysShipActionDialog ( props ) {

    const {

        id,
        schema,
        
        moveable,
        resizable,
        fullWidth,
        maxWidth,

        onClose,
        onInitialized,
        onSuccess,
        
        title,

        onShipSelectMst,        
        onDialogUpdateDetail,

        ...others

    } = props;

    const  classes = useStyles ();
    const { t } = useTranslation ();

    const [instance, setInstance] = useState ();
    const [disabled, setDisabled] = useState ( true );
    const [formData, setFormData] = useState({});
    const [keepOpen, setKeepOpen] = useState(true);
    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    const [shipDetailGrid, setShipDetailGrid] = useState();
    const [possibleShipLotGrid, setPossibleShipLotGrid] = useState();
    const [shipDetailSelect , setShipDetailSelect] = useState();
    const [possibleShipSelect , setPossibleShipLotSelect] = useState();

    const [, setIsEmpty] = useState();

    const [data, setData] = useState();


    useEffect(() => {

        (async () => {
            
          if (shipDetailGrid) {
              
            shipDetailGrid.selectionChanged.addHandler(debounce((grid, event) => {

                if(grid.selectedItems && grid.selectedItems[0]) {

                    setShipDetailSelect(grid.selectedItems[0]);
                } else {
                    setShipDetailSelect([]);
                }

            }), 10);
                
            shipDetailGrid.itemsSourceChanged.addHandler(debounce((grid, event) => {
                
                if(grid.selectedItems && grid.selectedItems[0]) {

                    setShipDetailSelect(grid.selectedItems[0]);
                }else {
                    setShipDetailSelect([]);
                }

            }), 10);

            shipDetailGrid.loadedRows.addHandler((flex, event) => {

                for (let row of flex.rows ) {

                    if(parseFloat(row.dataItem.shipmentQty) === parseFloat(row.dataItem.shipQty)) {

                        row.cssClass = `not-regist-materialByCompany`
                    }

                }
            });
          }
    
        })();

      }, [shipDetailGrid]);

    useEffect(() => {

        (async () => {
            
          if (possibleShipLotGrid) {

            possibleShipLotGrid.selectionChanged.addHandler((grid, event) => {

                if(grid.selectedItems && grid.selectedItems[0]) {

                    setPossibleShipLotSelect(grid.selectedItems[0]);
                } 


            })
                
            possibleShipLotGrid.itemsSourceChanged.addHandler((grid, event) => {
                
                if(grid.selectedItems && grid.selectedItems[0]) {

                    setPossibleShipLotSelect(grid.selectedItems[0]);
                } 
            });
        }
        })();

      }, [possibleShipLotGrid]);

    useEffect(()=>{

        if( shipDetailSelect ) {

            setFormData ( ( formData ) => {
    
                let newFormData = {
    
                    ...formData,
                    shipId: shipDetailSelect.shipId,
                    shipDetailId: shipDetailSelect.shipDetailId,
                    orderBuyerId: shipDetailSelect.orderBuyerId,
                    materialName: shipDetailSelect.materialName,
                    materialCode: shipDetailSelect.materialCode,
                    materialCodeVer: shipDetailSelect.materialCodeVer,
                    shipmentQty: shipDetailSelect.shipmentQty,
                    dueDate: shipDetailSelect.dueDate,
                    shipLotNo : onShipSelectMst.shipmentLot,
                    shipmentId : onShipSelectMst.shipmentId
                    
                };
    
                return newFormData;
    
            } );

            if( parseFloat(shipDetailSelect.shipmentQty) === parseFloat(shipDetailSelect.shipQty )) {

                schema.columns.filter((column) => column.name === "shipQty" || column.name === "description" )
                .map((column) => column.disabled = true)

            } else {

                schema.columns.filter((column) => column.name === "shipQty" || column.name === "description" )
                .map((column) => column.disabled = false)

                setDisabled(false);

            }
        }

    },[ shipDetailSelect ]);

    useEffect(() =>{

        if( data ) {

            if( data.length > 0 ) {

                setFormData ( ( formData ) => {
    
                    let newFormData = {
        
                        ...formData,
                        lotNo: possibleShipSelect?.lotNo,
                        shipQty : parseFloat(shipDetailSelect?.shipmentQty) - parseFloat(shipDetailSelect?.shipQty) > parseFloat(possibleShipSelect?.qtyCurrent) ? parseFloat(possibleShipSelect?.qtyCurrent) : parseFloat(parseFloat(shipDetailSelect?.shipmentQty) - parseFloat(shipDetailSelect?.shipQty)) ,
                    };
        
                    return newFormData;
        
                } )

                if( parseFloat(shipDetailSelect?.shipmentQty) === parseFloat(shipDetailSelect?.shipQty )) {

                    schema.columns.filter((column) => column.name === "shipQty" || column.name === "description" )
                    .map((column) => column.disabled = true);
    
                    setDisabled(true);
                } else {
                    
                    schema.columns.filter((column) => column.name === "shipQty" || column.name === "description" )
                    .map((column) => column.disabled = false);
    
                    setDisabled(false);
                    
                }
    
            } else {
                
                setFormData ( ( formData ) => {
    
                    let newFormData = {
        
                        ...formData,
                        lotNo: undefined,
                        shipQty : undefined,
                    };
        
                    return newFormData;
        
                } )

                schema.columns.filter((column) => column.name === "shipQty" || column.name === "description" )
                .map((column) => column.disabled = true);

                setDisabled(true);
    
    
            }
        }

    },[ possibleShipSelect, data ])


    const onShipDetailInitialized = ( grid ) => {

        grid.selectionMode = "Row";

        setShipDetailGrid ( grid );

    }

    const onPossibleShipLotInitialized = ( grid ) => {

        grid.selectionMode = "Row";
        setPossibleShipLotGrid ( grid );

    }

    const checkItemValidataion = ( schema, formData ) => {
        
        for ( const column of schema.columns ) {

            let [valid, msg] = checkValidation ( "create", column, column.validation, formData[column.name] || "" );

            if(column.name === "shipQty") {
                
                if(parseFloat(formData["shipQty"]) + parseFloat(shipDetailSelect.shipQty) > parseFloat(formData["shipmentQty"]) ) {

                    valid = false;

                    msg = t( "error.failToShipQty" );

                }
                else if(parseFloat((formData["shipQty"]).toFixed(5)) === 0 ) {
    
                    valid = false;

                    msg =  t("error.positiveFloatRequired");
                }
            }

            if ( !valid ) {

                nofifyWarning ( msg );
                return false;

            }
            
        }

        return true;

    }

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });

    };

    const onNotifySuccess = ( msg ) => {

        notifySuccess ( msg );

    };

    const nofifyWarning = (msg) => {

        console.warn (msg);

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });

    };

    const notifyFailure = (msg) => {

        console.error ( msg );

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    const onDialogInitialized = ( instance ) => {

        setInstance(instance);

        if ( onInitialized ) {

            onInitialized ( instance );

        }

    };

    const onApiSuccess = (result) => {

        setKeepOpen ( ( keepOpen ) => {

            if ( !keepOpen ) {

                instance.hide();

                if (onSuccess) {

                    setTimeout ( onSuccess(result.data), 0 );
        
                }

            } else {

                setShipDetailGrid ( ( grid ) => {

                if ( grid ) {

                    ( async () => {

                        let shipDetailMst = await getSpecific("MomSysVwShipDetail", grid.selectedItems[0].shipDetailId );

                        grid.selectedItems[0].shipQty = shipDetailMst.shipQty;
                        grid.refresh(false);

                        setTimeout((setShipDetailSelect(undefined)),0);
                        setTimeout((setShipDetailSelect(grid.selectedItems[0])),0);
        
                    } ) ();

                }

                return grid;

                })
                
                onNotifySuccess(result.data);
                
                if (onSuccess) {
                    setTimeout(() => onSuccess(result.data), 0);
                }


            }

            return keepOpen;

        } );

    };

    const onApiFailure = (reason) => {

        notifyFailure ( t ( "error.insertFailure", { reason: reason.response ? reason.response.data : JSON.stringify ( reason ) } ) );

    };

    const onOk = ( schema, formData ) => {

        if ( ! checkItemValidataion ( schema, formData ) ) {

            console.error ( "Form Validation Failed" );

            return;

        }

        if (schema.validation) {

            let [valid, msg] = checkConditionWithMsg(

                formData,
                schema.validation

            );

            if (!valid) {

                nofifyWarning ( t ( "warning.formDataValidationFail", { msg: msg } ) );
                return;

            }

        }

        // build base api url

        let url ;

        if(shipDetailSelect.standard === 1) {

            url = `/api/Material/${shipDetailSelect.orderBuyerId}/ship`;
        
        } else {

            url = `/api/NsMaterial/${shipDetailSelect.orderBuyerId}/ship`;
        }

        let apiData = { ...formData };
            
        let form = new FormData ();

        let json = {};
        let deleted = {};

        for ( const formItem in apiData ) {

            if ( apiData[formItem] !== undefined ) {

                json[formItem] = apiData[formItem];

            }

        }
        form.append ( "deleted", JSON.stringify ( deleted ) );
        form.append ( "json", JSON.stringify ( json ) );
        apiClient
            .post(url, form, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((result) => onApiSuccess(result))
            .catch((reason) => onApiFailure(reason));

    }

    const onCancel = () => {

        setFormData( null );

        setDisabled ( true );

        instance.hide();

    };

    const checkKeepOpen = () => {

        return (
            <>

                <FormControlLabel
                    control={

                        <Checkbox
                            className={classes.keepOpenSwitch}
                            checked={keepOpen}
                            color="primary"
                            onChange={ ()=> setKeepOpen( ( keepOpen ) => ( !keepOpen ) ) }
                            name="checkKeepOpen"
                            size="small"
                        />
                    }
                    label={<span className={classes.label}>{t("term.keepDialogOpen")}</span>}
                />
                <div style={{flexGrow: 1}}></div>

            </>

        )

    }

    const onChange = ( formData ) => {
        
        setFormData ( formData );

    }

    const onCloseNotification = () => {

        setNotification( ( notification ) => {

            return ({...notification, open: false});

        } );

    };

    const onCloseDialog = () => {

        setDisabled ( true );

        setFormData( null );
        
        if ( onClose ) {

            onClose ();

        }
    }

    const onLoadData = (data) => {

        setData(data);

        setIsEmpty(data.length < 1 ? true : false)

    }

    return (
        <Dialog
            id={id}
            moveable={moveable ? moveable : uiConf.dialogMoveable}
            resizable={resizable ? resizable : uiConf.dialogResizable}
            fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
            maxWidth="lg"
            onClose={onCloseDialog}
            onInitialized={onDialogInitialized}
            {...others}
        >

            <DialogHeaderWithClose>
                <DialogTitle>
                    { t ( "dialog.title.MomSysShip.create" ) }
                </DialogTitle>
            </DialogHeaderWithClose>

            <Divider />

            <DialogContent style={{padding: "0px", height: "600px"}}>

            <ReflexContainer orientation="vertical">

                <ReflexElement flex={0.65}>

                    <ReflexContainer orientation="horizontal">

                        <ReflexElement flex={0.5}>

                            <BasicCrudScreenType
                                id="MomSysVwShipDetail"
                                embededInOtherScreenType
                                view= "MomSysVwShipDetail"
                                headerTitle={t("term.shipDetail")}
                                noExcel
                                onModifyViewUrl = {(url) => `${url}/detail/${onShipSelectMst.shipId}`}
                                onInitialized = {onShipDetailInitialized}
                            />

                        </ReflexElement>

                        <ReflexSplitter style={{ height: layoutConf.reflex.splitterHeight }} />

                        <ReflexElement flex={0.5}>

                        {
                            shipDetailSelect ?

                            <MomSysSelectStadnardShipDetail
                                standard = {shipDetailSelect.standard}
                                onSelect = {shipDetailSelect}
                                onInitialized = {onPossibleShipLotInitialized}
                                onLoadData={onLoadData}
                            />
                            :
                            <></>
                        }
                            


                        </ReflexElement>

                    </ReflexContainer>

                </ReflexElement>

                <ReflexSplitter style={{ width: layoutConf.reflex.splitterWidth }}/>


                <ReflexElement flex={0.35}>

                        <div
                            style={{
                                padding: "16px"
                            }}                    
                        >

                            <AutoForm
                                id="order-purchase-detail-create-form"
                                schema={schema}
                                mode="edit"
                                initialData={formData}
                                onChange={onChange}
                            />

                        </div>


                </ReflexElement>



                </ReflexContainer>

                <Snackbar
                    open={notification.open && notification.severity !== "success"}
                    autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                    onClose={onCloseNotification}
                >
                    <Alert
                        onClose={onCloseNotification}
                        variant="filled"
                        severity={notification.severity}
                    >

                        {notification.msg}

                    </Alert>

                </Snackbar>

            </DialogContent>

            <Divider />

            <DialogActionsOkCancel
                firstActionComponent={checkKeepOpen}
                labels={[ t("common.add")]}
                buttonDisabled={[disabled, false]}
                onOk={() => onOk(schema, formData)}
                onCancel={onCancel}
            />

        </Dialog>

    );

}

export default MomSysShipActionDialog;